module.exports = __webpack_public_path__ + "static/media/control_3.404eddaf.svg";